module.exports = "<div class=\"ui-renderer\">\n    <app-ui-table [meta]=\"meta\" [data]=\"data\"></app-ui-table>\n</div>"